import { isDefined } from "./isDefined";

/**
 * Type guard for checking if a value is null or undefined.
 * Use `isDefined` helper if you want to check if a value is not null or undefined.
 */
function isNil(value: unknown): value is null | undefined {
  return !isDefined(value);
}

export { isNil };
